import { call, put } from 'redux-saga/effects';
import { saveChartOfAccountsTemplate } from '../api';
import {
  saveChartOfAccountsTemplateFailure,
  saveChartOfAccountsTemplateSuccess,
  fetchChartOfAccountsTemplatesRequest,
} from '../actions';
import { SaveChartOfAccountsTemplateRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { turnMessageOn, turnDrawerOff } from 'store/app/actions';
import { MessageStates } from 'containers/MessageBox';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundARY-TYPES */
export function* saveChartOfAccountsTemplateSaga(
  action: SaveChartOfAccountsTemplateRequestAction
) {
  try {
    let err: ApiError | null;
    const { organisationId, name, accountIds } = action.payload;

    const response: ApiResponse = yield call(
      saveChartOfAccountsTemplate,
      organisationId,
      name,
      accountIds
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(saveChartOfAccountsTemplateSuccess());

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: i18n.t('notifications.chart-of-accounts-template-saved-successfully'),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));

    // Refresh templates list so any other UIs (e.g. AddChartOfAccountsForm) see the new template
    yield put(fetchChartOfAccountsTemplatesRequest());

    // Close the drawer after successful save
    yield put(turnDrawerOff());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(saveChartOfAccountsTemplateFailure());
  }
}

